module.exports = __webpack_public_path__ + "static/media/omdb-movies-combined-macbook.1a76ac7c.png";